import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 77px;
  background: #F9F2EC;
  z-index: 1000;
`

export const Item = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;

  label {
    color: ${({isActive}) => isActive ? "#594E47" : "#594E47B2"};
  }

  div {
    background-color: ${({isActive}) => isActive ? "#7D5A42" : "#594E47B2"};
  }
`

export const IconMask = styled.div<{ icon: string, isActive?: boolean }>`
  width: 24px;
  height: 24px;
  mask-image: url(${({ icon }) => icon});
  -webkit-mask-image: url(${({ icon }) => icon});
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-size: contain;
  transition: background-color 0.3s ease;
`;
